export const itemTestId = 'Navigation-item';
export const instanceSelectValueContainer = 'Navigation-instance-select-value-container';
